<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slproductcategory}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slproductcategory:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slproductcategory:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center">
          <template slot-scope="scope">
             {{ getProduct(scope.row.productName) }}
          </template>
        </el-table-column>
        <el-table-column prop="productLogo" label="产品图标" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center">
          
        </el-table-column>
        <el-table-column prop="status" label="状态（1已上架、0未上架）" header-align="center" align="center">
          <template slot-scope="scope">
          {{ scope.row.status == '0' ? '未上架' : '已上架'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slproductcategory:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:slproductcategory:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slproductcategory-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slproductcategory/page',
        getDataListIsPage: true,
        exportURL: '/sys/slproductcategory/export',
        deleteURL: '/sys/slproductcategory',
        deleteIsBatch: true
      },
      productNames: [],
      dataForm: {
        id: ''
      }
    }
  },
  created(){
    this.getproductNameOptions()
  },
  methods:{
    getProduct(v){
      return  this.productNames.filter(item => item.value == v)[0]?.label
    },
        //初始产品名称下拉框中的选项
    async getproductNameOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=productName`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.productNames = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.productNames.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  },
  components: {
    AddOrUpdate
  }
}
</script>
